import { render, staticRenderFns } from "./portWork.vue?vue&type=template&id=f4868814&scoped=true&"
import script from "./portWork.vue?vue&type=script&lang=js&"
export * from "./portWork.vue?vue&type=script&lang=js&"
import style0 from "./portWork.vue?vue&type=style&index=0&id=f4868814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4868814",
  null
  
)

export default component.exports